export const FETCH_JOB_LIST = "FETCH_JOB_LIST";
export const FETCH_JOB_LIST_SUCCESS = "FETCH_JOB_LIST_SUCCESS";
export const FETCH_JOB_LIST_FAILURE = "FETCH_JOB_LIST_FAILURE";

export const FETCH_JOB_LISTS = "FETCH_JOB_LISTS";
export const FETCH_JOB_LISTS_SUCCESS = "FETCH_JOB_LISTS_SUCCESS";
export const FETCH_JOB_LISTS_FAILURE = "FETCH_JOB_LISTS_FAILURE";

export const CREATE_JOB_LIST = "CREATE_JOB_LIST";
export const CREATE_JOB_LIST_SUCCESS = "CREATE_JOB_LIST_SUCCESS";
export const CREATE_JOB_LIST_FAILURE = "CREATE_JOB_LIST_FAILURE";

export const POST_JOB_LIST = "POST_JOB_LIST";
export const POST_JOB_LIST_SUCCESS = "POST_JOB_LIST_SUCCESS";
export const POST_JOB_LIST_FAILURE = "POST_JOB_LIST_FAILURE";

export const PUT_JOB_LIST = "PUT_JOB_LIST";
export const PUT_JOB_LIST_SUCCESS = "PUT_JOB_LIST_SUCCESS";
export const PUT_JOB_LIST_FAILURE = "PUT_JOB_LIST_FAILURE";

export const DELETE_JOB_LIST = "DELETE_JOB_LIST";
export const DELETE_JOB_LIST_SUCCESS = "DELETE_JOB_LIST_SUCCESS";
export const DELETE_JOB_LIST_FAILURE = "DELETE_JOB_LIST_FAILURE";

export const FETCH_JOB_LISTS_FIELDS = "FETCH_JOB_LISTS_FIELDS";
export const FETCH_JOB_LISTS_FIELDS_SUCCESS = "FETCH_JOB_LISTS_FIELDS_SUCCESS";
export const FETCH_JOB_LISTS_FIELDS_FAILURE = "FETCH_JOB_LISTS_FIELDS_FAILURE";

export const FETCH_USER_GROUP_BY_NAME = "FETCH_USER_GROUP_BY_NAME";
export const FETCH_USER_GROUP_BY_NAME_SUCCESS =
  "FETCH_USER_GROUP_BY_NAME_SUCCESS";
export const FETCH_USER_GROUP_BY_NAME_FAILURE =
  "FETCH_USER_GROUP_BY_NAME_FAILURE";

export const CREATE_JOB_FOD = "CREATE_JOB_FOD";
export const CREATE_JOB_FOD_RESET = "CREATE_JOB_FOD_RESET";
export const CREATE_JOB_FOD_SUCCESS = "CREATE_JOB_FOD_SUCCESS";
export const CREATE_JOB_FOD_FAILURE = "CREATE_JOB_FOD_FAILURE";

export const DELETE_FOD = "DELETE_FOD";
export const DELETE_FOD_SUCCESS = "DELETE_FOD_SUCCESS";
export const DELETE_FOD_FAILURE = "DELETE_FOD_FAILURE";
export const DELETE_FOD_RESET = "DELETE_FOD_RESET";

// Delete Job Listing
export const DELETE_JOBS = "DELETE_JOBS";
export const DELETE_JOBS_SUCCESS = "DELETE_JOBS_SUCCESS";
export const DELETE_JOBS_FAILURE = "DELETE_JOBS_FAILURE";
export const DELETE_JOBS_RESET = "DELETE_JOBS_RESET";

// Reset Job Listing
export const RESET_JOB_LIST = "RESET_JOB_LIST";

// Mass Change Job Status
export const CHANGE_JOB_STATUS = "CHANGE_JOB_STATUS";
export const CHANGE_JOB_STATUS_SUCCESS = "CHANGE_JOB_STATUS_SUCCESS";
export const CHANGE_JOB_STATUS_FAILURE = "CHANGE_JOB_STATUS_FAILURE";
export const CHANGE_JOB_STATUS_RESET = "CHANGE_JOB_STATUS_RESET";
